import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Counts, DeactivateMemberProp } from "../../type";
import { get } from "../../util/APIService";
import { HttpStatus } from "../../enums/httpStatus";

export const countFeedbackRequestReceivedByMember = createAsyncThunk(
  "admin/requestFeedback/countRequests/received",
  async (requestParams: DeactivateMemberProp, storeActions) => {
    const url = `api/v1/admin/member/requests/received/count?memberId=${requestParams.memberId}`;
    const response: any = await get(url, storeActions);

    if (response.status === HttpStatus.OK) {
      return {
        status: HttpStatus.OK,
        data: await response.json(),
      };
    } else {
      return {
        status: response.status,
        text: await response.text(),
      };
    }
  }
);

const countRequestReceivedByMemberSlice = createSlice({
  name: "countRequestReceivedByMember",
  initialState: {
    status: null as number | null,
    loading: false as boolean,
    text: null as string | null,
    data: {
      allRequestCount: -1,
      pendingRequestCount: -1,
      closedRequestCount: -1,
    } as Counts | null,
  },
  reducers: {
    clearData: (state) => {
      state.status = null;
      state.loading = false;
      state.text = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(countFeedbackRequestReceivedByMember.fulfilled, (state, action) => {
      state.status = action.payload.status;
      state.loading = false;
      if (action.payload.data !== undefined) {
        state.data = action.payload.data;
        state.text = null;
      } else if (action.payload.text !== undefined) {
        state.data = null;
        state.text = action.payload.text;
      }
    });
    builder.addCase(countFeedbackRequestReceivedByMember.pending, (state) => {
      state.status = null;
      state.loading = true;
      state.data = null;
      state.text = null;
    });
    builder.addCase(countFeedbackRequestReceivedByMember.rejected, (state) => {
      state.status = 503;
      state.loading = false;
      state.data = null;
      state.text = null;
    });
  },
});

export const { clearData } = countRequestReceivedByMemberSlice.actions;

export default countRequestReceivedByMemberSlice;
